export const initMetricsTrackerForTests = () => {
    if (typeof window !== "undefined" && !window._paq) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://metrika.testkontur.ru/tracker/extern.js";

        script.onload = function () {
            if ("externTracker" in window) {
                // @ts-ignore
                window._paq = window.externTracker;
            }
        };
        document.head.appendChild(script);
    }
};
